import { SET_SELECTED_STRUCT_ITEM } from "../../../../enums/Request/leader.requests.types";

export const setSelectedStructItemAction = (item) => {
    return {
        type: SET_SELECTED_STRUCT_ITEM,
        payload: item,
    };
};